const {
  base,
  data,
  compare,
  indication,
  gradient,
  customers,
  map,
  entityHeader,
} = require('./colors.json');

export {
  base,
  data,
  compare,
  indication,
  gradient,
  customers,
  map,
  entityHeader,
};

export default {
  ...base,
  ...data,
  ...compare,
  ...indication,
  ...gradient,
  ...customers,
  ...map,
  ...entityHeader,
};
